import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import Select from 'react-select';

const DocumentLinkingSection = ({
  linkToStaff = false,
  onLinkToStaffChange,
  staffId = null,
  onStaffIdChange,
  staffList = [],
  linkToVehicle = false,
  onLinkToVehicleChange,
  vehicleId = null,
  onVehicleIdChange,
  vehicleList = []
}) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? '#667eea' : '#e9ecef',
      boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(102, 126, 234, 0.25)' : 'none',
      minHeight: '49px',
      height: '49px',
      borderRadius: '1rem',
      '&:hover': {
        borderColor: '#ced4da'
      }
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#667eea' : state.isFocused ? '#f8f9fa' : 'white',
      color: state.isSelected ? 'white' : '#495057',
      '&:active': {
        backgroundColor: '#667eea'
      }
    }),
    placeholder: (base) => ({
      ...base,
      color: '#6c757d'
    })
  };

  return (
    <div className="mt-4 pt-4" style={{ borderTop: '1px solid #e9ecef' }}>
      <h5 className="mb-3" style={{ color: '#495057', fontWeight: 600, borderBottom: '2px solid #e9ecef', paddingBottom: '8px' }}>
        Link Document To
      </h5>
      <Row>
        {/* Staff Linking */}
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              label="Staff Details"
              checked={linkToStaff}
              disabled={linkToVehicle}
              onChange={(e) => {
                if (onLinkToStaffChange) {
                  onLinkToStaffChange(e.target.checked);
                  if (e.target.checked) {
                    // Uncheck and clear vehicle when staff is selected
                    if (onLinkToVehicleChange) {
                      onLinkToVehicleChange(false);
                    }
                    if (onVehicleIdChange) {
                      onVehicleIdChange(null);
                    }
                  } else if (onStaffIdChange) {
                    onStaffIdChange(null);
                  }
                }
              }}
              style={{ marginBottom: '0.5rem' }}
            />
            {linkToStaff && (
              <Select
                className="basic-single"
                classNamePrefix="select"
                options={staffList.map((staff) => ({
                  value: staff.id,
                  label: `${staff.employee_code || ''} - ${[staff.first_name, staff.middle_name, staff.last_name].filter(Boolean).join(' ') || staff.name || 'N/A'}`,
                  data: staff,
                }))}
                value={
                  staffId
                    ? staffList
                        .map((staff) => ({
                          value: staff.id,
                          label: `${staff.employee_code || ''} - ${[staff.first_name, staff.middle_name, staff.last_name].filter(Boolean).join(' ') || staff.name || 'N/A'}`,
                          data: staff,
                        }))
                        .find((option) => String(option.value) === String(staffId)) || null
                    : null
                }
                onChange={(selectedOption) => {
                  if (onStaffIdChange) {
                    onStaffIdChange(selectedOption ? selectedOption.value : null);
                  }
                }}
                isClearable
                isSearchable
                placeholder="Select Staff Member"
                styles={customStyles}
              />
            )}
          </Form.Group>
        </Col>

        {/* Vehicle Linking */}
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              label="Vehicle Details"
              checked={linkToVehicle}
              disabled={linkToStaff}
              onChange={(e) => {
                if (onLinkToVehicleChange) {
                  onLinkToVehicleChange(e.target.checked);
                  if (e.target.checked) {
                    // Uncheck and clear staff when vehicle is selected
                    if (onLinkToStaffChange) {
                      onLinkToStaffChange(false);
                    }
                    if (onStaffIdChange) {
                      onStaffIdChange(null);
                    }
                  } else if (onVehicleIdChange) {
                    onVehicleIdChange(null);
                  }
                }
              }}
              style={{ marginBottom: '0.5rem' }}
            />
            {linkToVehicle && (
              <Select
                className="basic-single"
                classNamePrefix="select"
                options={vehicleList.map((vehicle) => ({
                  value: vehicle.id,
                  label: `${vehicle.registration_number || ''}${vehicle.maker || vehicle.model ? ` - ${[vehicle.maker, vehicle.model].filter(Boolean).join(' ')}` : ''}`,
                  data: vehicle,
                }))}
                value={
                  vehicleId
                    ? vehicleList
                        .map((vehicle) => ({
                          value: vehicle.id,
                          label: `${vehicle.registration_number || ''}${vehicle.maker || vehicle.model ? ` - ${[vehicle.maker, vehicle.model].filter(Boolean).join(' ')}` : ''}`,
                          data: vehicle,
                        }))
                        .find((option) => String(option.value) === String(vehicleId)) || null
                    : null
                }
                onChange={(selectedOption) => {
                  if (onVehicleIdChange) {
                    onVehicleIdChange(selectedOption ? selectedOption.value : null);
                  }
                }}
                isClearable
                isSearchable
                placeholder="Select Vehicle"
                styles={customStyles}
              />
            )}
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default DocumentLinkingSection;
